import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import { FLOW_TYPE } from '../../App/AppConstants';
import './SimpleHeader.less';

const LOCALE_PREFIX = 'components/header/header';

export class SimpleHeader extends Component {
    
    static propTypes = {
        flow: PropTypes.string.isRequired
    };
    
    render() {
        const {flow} = this.props;
        
        return (
            <header className="SimpleHeader">
                <div className="row-fluid">
                    <div className="span24">

                        <div id="cue-header">
                            {
                                (flow === FLOW_TYPE.VENICE) ? (
                                    <div id="cue-ppc-icon-venice" className="pull-left" />
                                ) : (
                                    <div id="cue-ppc-icon" className="pull-left" />
                                )
                            }
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default (injectIntl(SimpleHeader));
